
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.6 3.398a4.8 4.8 0 00-6.776 0L3.398 13.823a4.793 4.793 0 006.779 6.778l7.08-7.08a2.768 2.768 0 00-.121-3.756 2.8 2.8 0 00-3.875 0l-5.8 5.8a.661.661 0 00-.212.487.673.673 0 00.223.5.7.7 0 00.475.175l.32-.021 5.972-5.972a1.45 1.45 0 011.931 0 1.351 1.351 0 010 1.93l-6.961 6.959a3.477 3.477 0 01-4.832 0 3.4 3.4 0 010-4.832L14.801 4.367a3.479 3.479 0 014.832 0 3.421 3.421 0 010 4.832l-.21.224v.263a.667.667 0 00.214.49.657.657 0 00.969 0 4.8 4.8 0 000-6.779z"}})])
          )
        }
      }
    